module.exports = __webpack_public_path__ + "static/media/wind.73e9dcbf.png";